import { useEffect } from 'react';
import { getThirdPartyLoader } from '../utils/optimizedThirdPartyLoader';

/**
 * Enhanced AdSense Script Component with 100% Render Complete Detection
 * Uses optimized third-party loader to ensure scripts load only after render completion
 */

// Declare adsbygoogle for TypeScript
declare global {
  interface Window {
    adsbygoogle: any[];
  }
}

const AdSenseScript: React.FC = () => {
  useEffect(() => {
    // Get the optimized third-party loader instance
    const loader = getThirdPartyLoader();
    
    // Signal to React that the app is ready for third-party loading
    const signalReactReady = () => {
      // Dispatch custom event for render completion detection
      window.dispatchEvent(new CustomEvent('react-app-ready'));
      console.log('📡 [AdSenseScript] React app ready signal dispatched');
    };

    // Delay signal slightly to ensure component is fully mounted
    const readyTimeout = setTimeout(signalReactReady, 100);

    // Log current loader status for debugging
    if (process.env.NODE_ENV === 'development') {
      const status = loader.getStatus();
      console.log('🔧 [AdSenseScript] Loader Status:', status);
      
      // Force load for development testing
      if (window.location.hostname === 'localhost') {
        console.log('🔧 [AdSenseScript] Development mode - checking loader state');
      }
    }

    return () => {
      clearTimeout(readyTimeout);
    };
  }, []);

  // This component doesn't render anything
  return null;
};

export default AdSenseScript; 